<template>
  <div class="home">
    <div v-wechat-title="$route.meta.title"></div>
    <Header :op="opacity" title="首页"></Header>
    <div class="swipe">
      <el-carousel indicator-position="none" height="100vh">
        <el-carousel-item v-for="(item, index) in banner" :key="index">
          <img class="sa" :src="item.src" @click="toDetail(item.url)">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="wrapper" ref="wrapper" :style="'opacity:' + opacity">
      <!-- 经典案例 -->
      <div class="block">
        <!-- title more -->
        <div class="f-c-b">
          <div class="title font-700">
            经典案例<span> PROJECTS</span>
          </div>
          <div class="more" @click="$router.push({ path: '/projects' })">MORE+</div>
        </div>
        <!-- main -->
        <el-row :gutter="10">
          <el-col :span="12" :lg="12" :sm="24" :xs="24">
            <div class="">
              <el-row :gutter="10">
                <el-col :span="12" :lg="12" :sm="12" :xs="12">
                  <el-row :gutter="10">
                    <el-col :span="24" :lg="24" :sm="24" :xs="24">
                      <div class="news-item" @mouseover="tipOver(0)" @mouseleave="tipLeave(0)" @click="toDetail(projects[0].url)">
                        <img class="news-item-bg" :src="projects.length > 0 ? projects[0].src: ''" alt="">
                        <transition name="el-zoom-in-bottom">
                          <div class="news-item-tip b-black p-20 t-l" v-if="tipShow[0]">
                            <div class="ellipsis-2 m-10-0" :class="mode === 'pc' ? 'font-26' : 'font-16'">{{projects.length > 0 ? projects[0].name: '--'}}</div>
                            <div class="m-10-0" :class="mode === 'pc' ? 'font-36' : 'font-20'">{{projects.length > 0 ? projects[0].text: '--'}}</div>
                          </div>
                        </transition>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="24" :lg="24" :sm="24" :xs="24">
                      <div class="news-item" @mouseover="tipOver(1)" @mouseleave="tipLeave(1)" @click="toDetail(projects[1].url)">
                        <img class="news-item-bg" :src="projects.length > 0 ? projects[1].src: ''" alt="">
                        <transition name="el-zoom-in-bottom">
                          <div class="news-item-tip b-black p-20 t-l" v-if="tipShow[1]">
                            <div class="ellipsis-2 m-10-0" :class="mode === 'pc' ? 'font-26' : 'font-16'">{{projects.length > 0 ? projects[1].name: '--'}}</div>
                            <div class="m-10-0" :class="mode === 'pc' ? 'font-36' : 'font-20'">{{projects.length > 0 ? projects[1].text: '--'}}</div>
                          </div>
                        </transition>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="12" :lg="12" :sm="12" :xs="12">
                  <el-row :gutter="10">
                    <el-col :span="24" :lg="24" :sm="24" :xs="24">
                      <div class="news-item" @mouseover="tipOver(2)" @mouseleave="tipLeave(2)" @click="toDetail(projects[2].url)">
                        <img class="news-item-bg" :src="projects.length > 0 ? projects[2].src: ''" alt="">
                        <transition name="el-zoom-in-bottom">
                          <div class="news-item-tip b-black p-20 t-l" v-if="tipShow[2]">
                            <div class="ellipsis-2 m-10-0" :class="mode === 'pc' ? 'font-26' : 'font-16'">{{projects.length > 0 ? projects[2].name: '--'}}</div>
                            <div class="m-10-0" :class="mode === 'pc' ? 'font-36' : 'font-20'">{{projects.length > 0 ? projects[2].text: '--'}}</div>
                          </div>
                        </transition>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="12" :lg="12" :sm="24" :xs="24">
            <div class="">
              <el-row :gutter="10">
                <el-col :span="24" :lg="24" :sm="24" :xs="24">
                  <div class="news-item" @mouseover="tipOver(3)" @mouseleave="tipLeave(3)" @click="toDetail(projects[3].url)">
                    <img class="news-item-bg" :src="projects.length > 0 ? projects[3].src: ''" alt="">
                    <transition name="el-zoom-in-bottom">
                      <div class="news-item-tip b-black p-20 t-l" v-if="tipShow[3]">
                        <div class="ellipsis-2 m-10-0" :class="mode === 'pc' ? 'font-26' : 'font-16'">{{projects.length > 0 ? projects[3].name: '--'}}</div>
                        <div class="m-10-0" :class="mode === 'pc' ? 'font-36' : 'font-20'">{{projects.length > 0 ? projects[3].text: '--'}}</div>
                      </div>
                    </transition>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="12" :lg="12" :sm="12" :xs="12">
                  <div class="news-item" @mouseover="tipOver(4)" @mouseleave="tipLeave(4)" @click="toDetail(projects[4].url)">
                    <img class="news-item-bg" :src="projects.length > 0 ? projects[4].src: ''" alt="">
                    <transition name="el-zoom-in-bottom">
                      <div class="news-item-tip b-black p-20 t-l" v-if="tipShow[4]">
                        <div class="ellipsis-2 m-10-0" :class="mode === 'pc' ? 'font-26' : 'font-16'">{{projects.length > 0 ? projects[4].name: '--'}}</div>
                        <div class="m-10-0" :class="mode === 'pc' ? 'font-36' : 'font-20'">{{projects.length > 0 ? projects[4].text: '--'}}</div>
                      </div>
                    </transition>
                  </div>
                </el-col>
                <el-col :span="12" :lg="12" :sm="12" :xs="12">
                  <div class="news-item" @mouseover="tipOver(5)" @mouseleave="tipLeave(5)" @click="toDetail(projects[5].url)">
                    <img class="news-item-bg" :src="projects.length > 0 ? projects[5].src: ''" alt="">
                    <transition name="el-zoom-in-bottom">
                      <div class="news-item-tip b-black p-20 t-l" v-if="tipShow[5]">
                        <div class="ellipsis-2 m-10-0" :class="mode === 'pc' ? 'font-26' : 'font-16'">{{projects.length > 0 ? projects[5].name: '--'}}</div>
                        <div class="m-10-0" :class="mode === 'pc' ? 'font-36' : 'font-20'">{{projects.length > 0 ? projects[5].text: '--'}}</div>
                      </div>
                    </transition>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- new 经典案例 -->
      <!--<div class="block">
        &lt;!&ndash; title more &ndash;&gt;
        <div class="f-c-b">
          <div class="title font-700">
            经典案例<span> PROJECTS</span>
          </div>
          <div class="more" @click="$router.push({ path: '/projects' })">MORE+</div>
        </div>
        &lt;!&ndash; main &ndash;&gt;
        <el-row :gutter="10">
          <el-col :span="12" :lg="12" :sm="12" :xs="24">
            <div class="f-c">
              <div class="f-1" ref="abcd">
                <div>
                  <img src="../assets/images/projects_1/p1.jpg" alt="">
                </div>
                <div class="m-t-10">
                  <img src="../assets/images/projects_1/p2.jpg" alt="">
                </div>
              </div>
              <div class="f-1 m-l-10">
                <img src="../assets/images/projects_1/p3.jpg" alt="">
              </div>
            </div>
          </el-col>
          <el-col :span="12" :lg="12" :sm="12" :xs="24">
            <div :class="mode === 'pc' ? '' : 'm-t-10'">
              <div class="">
                <img src="../assets/images/projects_1/p4.jpg" alt="">
              </div>
              <div class="f-c m-t-10">
                <div class="f-1">
                  <img src="../assets/images/projects_1/p5.jpg" alt="">
                </div>
                <div class="f-1 m-l-10">
                  <img src="../assets/images/projects_1/p6.jpg" alt="">
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>-->
      <!-- 资讯动态 -->
      <div class="block">
        <!-- title more -->
        <div class="f-c-b">
          <div class="title font-700">
            资讯动态<span> NEWS</span>
          </div>
          <div class="more" @click="$router.push({ path: '/news' })">MORE+</div>
        </div>
        <!-- main -->
        <div class="main">
          <el-row :gutter="10">
            <el-col :span="8" :lg="8" :sm="24" :xs="24" v-for="(item, index) in news" :key="index">
              <div class="news-item" @mouseover="tipOver(index + 6)" @mouseleave="tipLeave(index + 6)" @click="$router.push({ path: '/newsdetail', query: { id: item.id } })">
                <img class="news-item-bg" :src="item.src" alt="">
                <transition name="el-zoom-in-top">
                  <div class="news-item-tip-left b-white t-l" v-if="tipShow[index + 6]">
                    <div class="tip-main">
                      <div class="font-700 m-10-0 tip-time ellipsis-2" :class="mode === 'pc' ? 'font-32' : 'font-16'">{{item.time}}</div>
                      <div class="tip-tittle">
                        <div class="font-700 m-10-0 ellipsis-2" :class="mode === 'pc' ? 'font-22' : 'font-16'">{{item.name}}</div>
                        <div class="c-666 m-10-0 ellipsis-2" :class="mode === 'pc' ? 'font-16' : 'font-14'">{{item.text}}</div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
            <!--<el-col :span="8" :lg="8" :sm="24" :xs="24">
              <div class="news-item" @mouseover="tipOver(6)" @mouseleave="tipLeave(6)" @click="toDetail(news[0].url)">
                <img class="news-item-bg" :src="news.length > 0 ? news[0].src: ''" alt="">
                <transition name="el-zoom-in-top">
                  <div class="news-item-tip-left b-white t-l" v-if="tipShow[6]">
                    <div class="tip-main">
                      <div class="font-700 m-10-0 tip-time ellipsis-2" :class="mode === 'pc' ? 'font-36' : 'font-20'">{{news.length > 0 ? news[0].time : '&#45;&#45;'}}</div>
                      <div class="tip-tittle">
                        <div class="font-700 m-10-0 ellipsis-2" :class="mode === 'pc' ? 'font-26' : 'font-18'">{{news.length > 0 ? news[0].name : '&#45;&#45;'}}</div>
                        <div class="c-666 m-10-0 ellipsis-2" :class="mode === 'pc' ? 'font-20' : 'font-16'">{{news.length > 0 ? news[0].text : '&#45;&#45;'}}</div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
            <el-col :span="8" :lg="8" :sm="24" :xs="24">
              <div class="news-item" @mouseover="tipOver(7)" @mouseleave="tipLeave(7)" @click="toDetail(news[1].url)">
                <img class="news-item-bg" :src="news.length > 0 ? news[1].src: ''" alt="">
                <transition name="el-zoom-in-top">
                  <div class="news-item-tip-left b-white t-l" v-if="tipShow[7]">
                    <div class="tip-main">
                      <div class="font-700 m-10-0 tip-time ellipsis-2" :class="mode === 'pc' ? 'font-36' : 'font-20'">{{news.length > 0 ? news[1].time : '&#45;&#45;'}}</div>
                      <div class="tip-tittle">
                        <div class="font-700 m-10-0 ellipsis-2" :class="mode === 'pc' ? 'font-26' : 'font-18'">{{news.length > 0 ? news[1].name : '&#45;&#45;'}}</div>
                        <div class="c-666 m-10-0 ellipsis-2" :class="mode === 'pc' ? 'font-20' : 'font-16'">{{news.length > 0 ? news[1].text : '&#45;&#45;'}}</div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
            <el-col :span="8" :lg="8" :sm="24" :xs="24">
              <div class="news-item" @mouseover="tipOver(8)" @mouseleave="tipLeave(8)" @click="toDetail(news[2].url)">
                <img class="news-item-bg" :src="news.length > 0 ? news[2].src: ''" alt="">
                <transition name="el-zoom-in-top">
                  <div class="news-item-tip-left b-white t-l" v-if="tipShow[8]">
                    <div class="tip-main">
                      <div class="font-700 m-10-0 tip-time ellipsis-2" :class="mode === 'pc' ? 'font-36' : 'font-20'">{{news.length > 0 ? news[2].time : '&#45;&#45;'}}</div>
                      <div class="tip-tittle">
                        <div class="font-700 m-10-0 ellipsis-2" :class="mode === 'pc' ? 'font-26' : 'font-18'">{{news.length > 0 ? news[2].name : '&#45;&#45;'}}</div>
                        <div class="c-666 m-10-0 ellipsis-2" :class="mode === 'pc' ? 'font-20' : 'font-16'">{{news.length > 0 ? news[2].text : '&#45;&#45;'}}</div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>-->
            <!--<el-col :span="6" :lg="6" :sm="12" :xs="24">
              <div class="news-item" @mouseover="tipOver(9)" @mouseleave="tipLeave(9)" @click="toDetail(news[3].url)">
                <img class="news-item-bg" :src="news.length > 0 ? news[3].src: ''" alt="">
                <transition name="el-zoom-in-top">
                  <div class="news-item-tip-left b-white t-l" v-if="tipShow[9]">
                    <div class="tip-main">
                      <div class="font-700 m-10-0 tip-time ellipsis-2" :class="mode === 'pc' ? 'font-36' : 'font-20'">{{news.length > 0 ? news[3].time : '&#45;&#45;'}}</div>
                      <div class="tip-tittle">
                        <div class="font-700 m-10-0 ellipsis-2" :class="mode === 'pc' ? 'font-26' : 'font-18'">{{news.length > 0 ? news[3].name : '&#45;&#45;'}}</div>
                        <div class="c-666 m-10-0 ellipsis-2" :class="mode === 'pc' ? 'font-20' : 'font-16'">{{news.length > 0 ? news[3].text : '&#45;&#45;'}}</div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>-->
          </el-row>
        </div>
      </div>
      <!-- 访客留言 -->
      <div class="block">
        <!-- title more -->
        <div class="f-c-b">
          <div class="title font-700">
            访客留言<span> GUESTBOOK</span>
          </div>
          <!--<div class="more">MORE+</div>-->
        </div>
        <!-- main -->
        <div class="main">
          <el-row :gutter="20">
            <el-col :span="8" :lg="8" :sm="24" :xs="24">
              <div class="c-input">
                <el-input
                  type="textarea"
                  :autosize="{minRows: 10, maxRows: 10}"
                  placeholder="请填写您的留言"
                  v-model="comments">
                </el-input>
              </div>
            </el-col>
            <el-col :span="8" :lg="8" :sm="24" :xs="24">
              <el-row :gutter="10"><el-col :span="12" :lg="12" :sm="12" :xs="24"><div class="c-input"><el-input v-model="cName" placeholder="请填写您的姓名"></el-input></div></el-col></el-row>
              <el-row :gutter="10"><el-col :span="24" :lg="24" :sm="24" :xs="24"><div class="c-input"><el-input v-model="cCompany" placeholder="请填写您的公司"></el-input></div></el-col></el-row>
              <el-row :gutter="10"><el-col :span="18" :lg="18" :sm="18" :xs="24"><div class="c-input"><el-input v-model="cPhone" placeholder="请填写您的联系方式"></el-input></div></el-col></el-row>
              <el-row :gutter="10"><el-col :span="24" :lg="24" :sm="24" :xs="24"><div class="c-input t-l"><el-button type="primary" @click="lySubmit"><div class="p-0-20">提交</div></el-button></div></el-col></el-row>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <el-backtop></el-backtop>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { getIndexImg, getCaseImg, getInquiryImg, setMessage } from '../http/api'

export default {
  name: 'Home',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      mode: '', // width > 678 pc else mobile
      horizontal: true, // 是否橫屏
      opacity: 0, // wrapper的透明度
      swipe: [require('@/assets/images/s3.jpg'), require('@/assets/images/s4.jpg'), require('@/assets/images/s5.jpg'), require('@/assets/images/s6.jpg')],
      banner: [], // 轮播
      projects: [], // 案例
      news: [], // 资讯
      comments: '',
      cName: '',
      cCompany: '',
      cPhone: '',
      tipShow: []
    }
  },
  created () {
    this.mode = this.$com.jugClientWidth() || 'pc'
    this.horizontal = this.$com.isHorizontal()
    if (this.mode === 'mobile') {
      const tipShow = new Array(10).fill(true)
      this.tipShow = tipShow
    } else {
      const tipShow = new Array(10).fill(false)
      this.tipShow = tipShow
    }
    this.onLoad()
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('scroll', this.handleScroll)
    })
    window.onresize = () => {
      this.horizontal = this.$com.isHorizontal()
      // this.banner = []
      this.onLoad()
      // console.log(this.horizontal)
    }
  },
  methods: {
    onLoad () {
      getIndexImg().then(res => {
        const data = res.data
        if (this.horizontal === true) {
          const banner = data.pc.sort(this.$com.sortAsc('list')) || []
          this.banner = banner
        } else {
          const banner = data.mt.sort(this.$com.sortAsc('list')) || []
          this.banner = banner
        }
      })
      getCaseImg().then(res => {
        const data = res.data || []
        this.projects = data.sort(this.$com.sortAsc('list'))
        // console.log(this.projects)
      })
      getInquiryImg().then(res => {
        const data = res.data || []
        // this.news = data.sort(this.$com.sortAsc('list'))
        this.news = data
        // console.log(this.news)
      })
    },
    tipOver (i) {
      if (this.mode === 'pc') {
        this.tipShow[i] = true
        this.tipShow = [...this.tipShow]
      }
    },
    tipLeave (i) {
      if (this.mode === 'pc') {
        this.tipShow[i] = false
        this.tipShow = [...this.tipShow]
      }
    },
    handleScroll () {
      // this.$refs.wrapper.offsetTop 元素距离文档顶端偏移值 -
      // document.documentElement.scrollTop 网页被卷起来的高度
      // = 页面元素距离浏览器工作区顶端的距离
      const scrollTop = this.$com.getScrollTop()
      const ot = this.$refs.wrapper.offsetTop - scrollTop - 300
      let op = (document.documentElement.clientHeight - ot) * (1 / document.documentElement.clientHeight)
      if (op > 1) op = 1
      this.opacity = op
    },
    toDetail (url) {
      if (url) {
        window.location.href = url
      }
    },
    lySubmit () {
      const data = {
        name: this.cName,
        company: this.cCompany,
        linkNumber: this.cPhone,
        text: this.comments
      }
      if (!data.name) {
        this.$message.warning('请填写您的姓名')
        return
      }
      if (!data.company) {
        this.$message.warning('请填写您的公司')
        return
      }
      if (!data.linkNumber) {
        this.$message.warning('请填写您的联系方式')
        return
      }
      if (!data.text) {
        this.$message.warning('请填写您的留言')
        return
      }
      setMessage(data).then(() => {
        this.$message.success('留言成功')
        this.cName = ''
        this.cCompany = ''
        this.cPhone = ''
        this.comments = ''
      })
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style lang="scss" scoped>
  .swipe{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: -1;
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .wrapper{
    width: 100%;
    margin-top: 100vh;
    /*height: 2000px;*/
    background-color: #ffffff;
    .block{
      padding: 20px 0;
      .title{
        color: #000000;
        padding: 20px 0;
      }
      .more{
        cursor: pointer;
        padding: 6px 20px;
        color: #000000;
        border: 2px solid #000000;
        border-radius: 20px;
        &:hover{
          background-color: var(--theme);
          border: 2px solid var(--theme);
          color: #ffffff;
        }
      }
      .c-input{
        margin: 10px 0;
      }
    }
    img {
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
  }
  @media (min-width: 1024px) {
    .wrapper {
      padding: 20px 64px;
      width: calc(100% - 128px);
      .title {
        font-size: 30px;
        span{
          font-size: 20px;
        }
      }
      .more{
        cursor: pointer;
        padding: 10px 26px;
        border-radius: 24px;
      }
    }
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    .wrapper {
      padding: 20px;
      width: calc(100% - 40px);
      .title {
        font-size: 30px;
        span{
          font-size: 20px;
        }
      }
    }
  }
  @media (max-width: 767px) {
    .wrapper {
      padding: 10px;
      width: calc(100% - 20px);
      .title {
        font-size: 24px;
        span{
          font-size: 18px;
        }
      }
    }
  }
</style>
